import React from 'react';
import PropTypes from 'prop-types';
import ListBox from 'carbon-components-react/lib/components/ListBox';
import { optimizeLabel } from './helper';

const ResultsBox: React.FC<Props> = (props) => {
  const { items, onItemClick } = props;

  return (
    <div className={`bx--list-box__wrapper`}>
      <ListBox className="bx--combo-box" isOpen={true}>
        <ListBox.Menu
          id="address-search-list-menu"
          className="address-search-list-menu"
        >
          {items.map((item: any, inx: number) => {
            return (
              <ListBox.MenuItem
                key={inx}
                onClick={() =>
                  typeof onItemClick === 'function' && onItemClick(item)
                }
              >
                {optimizeLabel(item.Value, item.CustomFields)}
              </ListBox.MenuItem>
            );
          })}
        </ListBox.Menu>
      </ListBox>
    </div>
  );
};

const propTypes = {
  items: PropTypes.any,
  onItemClick: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

ResultsBox.defaultProps = {
  items: []
};

export default ResultsBox;
